import React from 'react';
import classNames from 'classnames';

import style from './Alert.module.scss';
import AlertIconTop from '../../images/alert-icon-top.svg';
import AlertIconBottom from '../../images/alert-icon-bottom.svg';
import { Tappable } from '../../soonmoo';

export type AlertPosition = 'top' | 'bottom';
export type AlertType = 'normal' | 'error';

interface AlertProps {
  onRemove: () => void;
  message: string;
  seconds?: number;
  closed?: boolean;
  position: AlertPosition;
  type: AlertType;
  iconDisabled?: boolean;
  kiosk?: boolean;
}

interface AlertState {
  beforeOpen: boolean;
  opening: boolean;
  closing: boolean;
  timeoutId: number;
}

export default class Alert extends React.Component<AlertProps, AlertState> {
  static defaultProps = {
    seconds: 3,
    closed: false,
    type: 'normal',
  };
  dom?: HTMLElement;
  constructor(props: AlertProps) {
    super(props);
    this.state = {
      beforeOpen: true,
      opening: false,
      closing: false,
      timeoutId: -1,
    };
    this.dom = undefined;
  }
  clearTimeout() {
    window.clearTimeout(this.state.timeoutId);
  }
  onTransitionEnd() {
    const { state, props } = this;
    if (state.opening) {
      const timeoutId = window.setTimeout(() => {
        this.setState({
          closing: true,
        });
      }, props.seconds! * 1000);
      this.setState({
        opening: false,
        timeoutId,
      });
    } else {
      props.onRemove();
    }
  }
  componentDidMount() {
    void this.dom!.offsetHeight; // transition hack
    this.setState({
      beforeOpen: false,
      opening: true,
    });
  }
  render() {
    const { state, props } = this;
    return (
            <Tappable
                _ref={dom => (this.dom = dom)}
                className={classNames(
                    props.position === 'top' ? style.alertTop : style.alertBottom,
                  {
                    [style.error]: props.type === 'error',
                    [style.closed]: state.beforeOpen ? true : this.state.closing,
                  },
                )}
                onClick={
                    this.state.closing
                        ? undefined
                        : () =>
                              this.setState({
                                opening: false,
                                closing: true,
                              })
                }
                onTransitionEnd={() => {
                  this.clearTimeout();
                  this.onTransitionEnd();
                }}
            >
                {props.iconDisabled === false && props.position === 'top' && (
                    <AlertIconTop className={style.icon} />
                )}
                {props.iconDisabled === false && props.position === 'bottom' && (
                    <AlertIconBottom className={style.icon} />
                )}
                <div className={style.message}>
                    {props.message}
                </div>
            </Tappable>
    );
  }
}
